const ADMIN_ROUTE_RULES = [
  { path: '/admin', permissions: ['DASHBOARD_VIEW'] },
  { path: '/admin/dashboard', permissions: ['DASHBOARD_VIEW'] },
  { path: '/admin/analytics', permissions: ['REPORT_VIEW', 'DASHBOARD_VIEW'] },
  { path: '/admin/visitor-analytics', permissions: ['REPORT_VIEW'] },
  { path: '/admin/properties', permissions: ['PROPERTY_VIEW', 'PROPERTY_MANAGE'] },
  { path: '/admin/bookings', permissions: ['BOOKING_VIEW', 'BOOKING_MANAGE'] },
  { path: '/admin/payments/transactions', permissions: ['PAYMENT_VIEW', 'PAYMENT_MANAGE'] },
  { path: '/admin/payouts', permissions: ['PAYOUT_MANAGE'] },
  { path: '/admin/hosts', permissions: ['HOST_VIEW', 'HOST_MANAGE', 'KYC_VIEW', 'KYC_MANAGE'] },
  { path: '/admin/messages', permissions: ['SUPPORT_VIEW', 'SUPPORT_MANAGE'] },
  { path: '/admin/content/banners', permissions: ['BANNER_MANAGE', 'BLOG_MANAGE'] },
  { path: '/admin/email', permissions: ['EMAIL_VIEW', 'EMAIL_MANAGE', 'REPORT_VIEW', 'BLOG_MANAGE'] },
  { path: '/admin/pricing/coupons', permissions: ['COUPON_MANAGE'] },
  { path: '/admin/reports/revenue', permissions: ['REPORT_VIEW'] },
  { path: '/admin/channel/providers', permissions: ['API_MANAGE'] },
  { path: '/admin/settings/roles', permissions: ['ROLE_MANAGE'] },
  { path: '/admin/settings/sub-admins', permissions: ['ROLE_MANAGE'] },
  { path: '/admin/settings/audit-logs', permissions: ['AUDIT_VIEW'] },
  { path: '/admin/settings/system', permissions: ['SETTINGS_MANAGE'] },
  { path: '/admin/roles', permissions: ['ROLE_MANAGE'] },
  { path: '/admin/sub-admins', permissions: ['ROLE_MANAGE'] },
  { path: '/admin/audit-logs', permissions: ['AUDIT_VIEW'] },
];

const SORTED_ROUTE_RULES = [...ADMIN_ROUTE_RULES].sort((a, b) => b.path.length - a.path.length);

export const resolveAdminLandingPath = ({ user, hasPermission, isSuperAdmin }) => {
  if (user?.mustChangePassword) {
    return '/admin/change-password';
  }
  if (isSuperAdmin || hasPermission?.('DASHBOARD_VIEW')) {
    return '/admin';
  }
  const next = ADMIN_ROUTE_RULES.find((item) => item.permissions.some((permission) => hasPermission?.(permission)));
  return next?.path || '/admin/login';
};

export const canAccessAdminPath = ({ pathname, hasPermission, isSuperAdmin }) => {
  if (!pathname || isSuperAdmin) return true;
  const rule = SORTED_ROUTE_RULES.find((item) =>
    item.path === '/admin' ? pathname === '/admin' : pathname === item.path || pathname.startsWith(`${item.path}/`)
  );
  if (!rule) return true;
  return rule.permissions.some((permission) => hasPermission?.(permission));
};
